import TableContainer from 'Common/TableContainer';
import { Plus } from 'lucide-react';
import React from 'react'
import { useListOptions } from '../../hooks';
import { ModalAddOption } from '../../components';
import DeleteModal from 'Common/DeleteModal';
import { useTranslation } from 'react-i18next';

const OptionesMenuView = () => {
  const {
    columns,
    optionsList,
    handleAddOption,
    deleteModal,
    handleDelete,
    deleteToggle,
  } = useListOptions();
  const { t } = useTranslation();
  
  return (
    <div>
      <div className='grid grid-cols-1 gap-x-5 xl:grid-cols-3 m-8'>
        <div className='xl:col-span-12'>
          <div className='card' id='usersTable'>
            <div className='card-body'>
              <div className='flex items-center'>
                <h6 className='text-15 grow'>
                  {t('createOption.titleListPage')}
                </h6>
                <div className='shrink-0'>
                  <button
                    type='button'
                    onClick={handleAddOption}
                    className='text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20'
                  >
                    <Plus className='inline-block size-4' />{' '}
                    <span className='align-middle'>
                      {' '}
                      {t('createOption.addNewOptionBtn')}
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div className='!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500'></div>
            <div className='card-body'>
              {optionsList && optionsList.length > 0 ? (
                <TableContainer
                  isPagination={true}
                  columns={columns || []}
                  data={optionsList || []}
                  customPageSize={10}
                  divclassName='-mx-5 -mb-5 overflow-x-auto'
                  tableclassName='w-full border-separate table-custom border-spacing-y-1 whitespace-nowrap'
                  theadclassName='text-left relative rounded-md bg-slate-100 dark:bg-zink-600 after:absolute ltr:after:border-l-2 rtl:after:border-r-2 ltr:after:left-0 rtl:after:right-0 after:top-0 after:bottom-0 after:border-transparent [&.active]:after:border-custom-500 [&.active]:bg-slate-100 dark:[&.active]:bg-zink-600'
                  thclassName='px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold'
                  tdclassName='px-3.5 py-2.5 first:pl-5 last:pr-5'
                  PaginationClassName='flex flex-col items-center mt-8 md:flex-row'
                />
              ) : (
                <div className='noresult'>
                  <div className='py-6 text-center'>
                    <h5 className='mt-2 mb-1'>{t('createOption.dataError')}</h5>
                    <p className='mb-0 text-slate-500 dark:text-zink-200'>
                      {t('createOption.dataMessage')}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ModalAddOption></ModalAddOption>
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
    </div>
  );
}

export default OptionesMenuView